const notificationClickActionTypes = () => {
  return {
    expired: '1'
  };
};

export default notificationClickActionTypes;
